import React from "react";
import {
  Modal,
  Container,
  Row,
  Col,
  Table,
  Spinner
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import classes from "./SpeciesModal.module.css";
import CloseButton from '../UI/CloseButton/CloseButton';
import { IActiveSpeciesOtherNames } from "../../components/UI/Table/Table";
import { API_URLS, getSearchSpeciesQuery, selectOptions } from "../../shared/utility";
import graphQLClientInstance from "../../axios-graphql-client";

const SpeciesModal = (props: any) => {
  const { t } = useTranslation();
  const [data, setData] = React.useState<IActiveSpeciesModal|null>(null);

  React.useEffect(() => {
    if (props.show && props.species_id) {
      if (!props.data) {
        setData(null);
        const searchSpeciesValues = {
          speciesCode: props.species_id,
          speciesCodeSelect: selectOptions.EXACT,
          speciesLatinName: props.princ_bot,
          speciesLatinNameSelect: selectOptions.EXACT
        }
        graphQLClientInstance.post(API_URLS.GRAPHQL, getSearchSpeciesQuery(searchSpeciesValues, 1, 0))
        .then(res => {
          if (res.data?.data?.speciesSearch?.data) {
            const speciesSearchData = res.data.data.speciesSearch.data[0];
            setData(
              {
                ...speciesSearchData,
                other_names: {
                  latin: speciesSearchData.other_bot,
                  en: speciesSearchData.en,
                  fr: speciesSearchData.fr,
                  de: speciesSearchData.de,
                  es: speciesSearchData.es
                }
              }
            )
          }
        })
        .catch(err => {
          console.log(err);
        });
      } else {
        setData({
          princ_bot: props.princ_bot,
          species_id: props.species_id,
          species_upov: props.species_upov,
          class_data: props.data.class_data,
          crop_sectors: props.data.crop_sectors,
          comments: props.data.comments,
          other_names: props.data.other_names
        })
      }
    }
  }, [props]);

  return (
    <Modal centered show={props.show} onHide={() => props.setShow(false)} size="lg">
      <Modal.Header className={classes.header}>
        <CloseButton onClick={() => props.setShow(false)} />
        <Modal.Title>{t("species")}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={classes.body}>
      {data?(
        <Container>
          <Row>
            <Col md="3" className="mb-1">
              {t("principal_botanical_name")}
            </Col>
            <Col md="9" className="font-weight-bold">{data.princ_bot}</Col>
            <Col md="3" className="mb-1">
              {t("species_code")}
            </Col>
            <Col md="9">{data.species_id}</Col>
            <Col md="3" className="mb-1">
              {t("upov_code")}
            </Col>
            <Col md="9">{data.species_upov}</Col>
            <Col md="3" className="mb-1">
              {t("crop_sectors")}
            </Col>
            <Col md="9">
              {data?.crop_sectors?.map((cropSector: any, index: number) => (
                <React.Fragment key={`crop-sector-${index}`}>
                  {/* @ts-ignore */}
                  <span>{data?.crop_sectors?.length > 1? "- " : ""}{cropSector}</span>
                  {/* @ts-ignore */}
                  {data?.crop_sectors?.length > 1 && index < data?.crop_sectors?.length - 1 ? <br /> : <></>}
                </React.Fragment>
              ))}
            </Col>
            <Col md="3" className="mb-1">
              {t("other_names")}
            </Col>
            <Col md="9">
              <Table striped hover size="sm" className={classes.namesTable}>
                <thead>
                  <tr>
                    <th>{t("language")}</th>
                    <th>{t("name")}</th>
                  </tr>
                </thead>
                <tbody>
                  {data.other_names !== undefined && data.other_names !== null ? (
                    Object.keys(data.other_names)?.filter((lang: string) =>
                      // @ts-ignore
                      data?.other_names[lang]?.length
                    ).map((lang: string, langIndex: number) => {
                      // @ts-ignore
                      return data.other_names[lang].map((name: string, nameIndex: number) => (
                        <tr key={`other-names-${langIndex}-${nameIndex}`}>
                          <td>{t(`languages.${lang}`)}</td>
                          <td>{name}</td>
                        </tr>
                      ));
                    })
                  ) : (
                    <></>
                  )}
                </tbody>
              </Table>
            </Col>

            <Col md="3" className="mt-4">
              {t("classes")}
            </Col>
            <Col md="9" className="mt-4">
              <Table striped hover size="sm" className={classes.namesTable}>
                <thead>
                  <tr>
                    <th>{t("class")}</th>
                    <th>{t("description")}</th>
                    <th>{t("type")}</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.class_data?.map((classItem: any, classIndex: number) =>
                     (
                      <tr key={`classes-${classIndex}`}>
                        <td>{classItem?.class_id}</td>
                        <td>{classItem?.class_name}</td>
                        <td>{classItem?.class_type_value}</td>
                      </tr>
                    ))
                  }
                </tbody>
              </Table>
            </Col>

            <Col md="3" className="mt-4">
              {t("comments")}
            </Col>
            <Col md="9" className="mt-4">
              {data?.comments}
            </Col>
          </Row>
        </Container>
        ):<div className="text-center"><Spinner animation="border" variant="primary" /></div>}
      </Modal.Body>
    </Modal>
  );
};

export interface IActiveSpeciesModal {
  princ_bot?: string;
  species_id?: string;
  species_upov?: string;
  crop_sectors?: string[];
  class_data?: {
    classid?: string;
    class_name?: string;
    class_type?: string;
    class_type_value?: string | number;
  }[];
  comments?: string;
  other_names?: IActiveSpeciesOtherNames;
}

export default SpeciesModal;
